import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
//import get from 'lodash/get';
//import cn from 'classnames';
import css from './css.css';
import NavigatableSearchTable from './NavigatableSearchTable';
import {getModelTitle, getSearchModel} from "~/stateGetter";
import LoadingContainer from "~/ui/Loading/LoadingContainer";
import { H1, VStack, } from "~/native-ui";

export class ModelResult extends Component {
	static propTypes = {
	
	};

	render() {
		if(this.props.total < 1) {
			return null;
		}

		let modelName = this.props.modelName;

		return (
			<VStack position="relative">
				<LoadingContainer className="loadingContainer" modelName={modelName} loading={[`searchResultLoading`]}>
					<VStack mt="8" space="2">
						<H1 ml="2">{ this.props.title }</H1>
						{/* <div className={css.bar}>
						<h3>{this.props.title}</h3>
						</div> */}

						<NavigatableSearchTable modelName={modelName} autoHidePagination={true} />

					</VStack>
				</LoadingContainer>
			</VStack>
		);
	}
}
const RXModelResult = connect(
    (state, { modelName }) =>  {
    	let searchModel = getSearchModel(state, modelName);

        return {
        	total: searchModel.results.value.total,
        	title: getModelTitle(state, modelName)
        }    
    },
    (dispatch) => ({
        
    })
)(ModelResult);

export default RXModelResult;